import React from "react";

import { RovingAccessibleButton } from "../RovingTabIndex";

interface IProps extends React.ComponentProps<typeof RovingAccessibleButton> {
    label?: string;
}

// Semantic component for representing a role=menuitem
export const MenuItem: React.FC<IProps> = ({ children, label, ...props }) => {
    const ariaLabel = props["aria-label"] || label;

    return (
        <RovingAccessibleButton {...props} role="menuitem" aria-label={ariaLabel}>
            {children}
        </RovingAccessibleButton>
    );
};
